import React ,{useState,useEffect}from "react";
import { Button, Form, Input, message } from "antd";
import { useNavigate ,useLocation} from "react-router-dom";


import "../App.css";
import { URL } from "../helper/Mainurl";
import { HeaderSection } from "./HeaderSection";
import { FooterSection } from "./FooterSection";

const ForgetPassword = () => {
    const location = useLocation();


    const emailFromState = location.state?.email || "";

    const [email, setEmail] = useState(emailFromState); // State for the email field


  const [form] = Form.useForm();

  

 console.log("email:::::::",location.state.email)

 useEffect(() => {
  if (emailFromState) {
    form.setFieldsValue({ email: emailFromState });

    // ✅ Manually trigger validation to remove "Email is required" error
    form.validateFields(["email"]);
  }
}, [emailFromState, form]);

 
const emailValue =(e)=>{
  setEmail(e.target.value)
}
 const handleClick = async (values) => {
    const payload = {
      email: values.email,
    };
    try {
      const response = await fetch(`${URL}/send-reset-password-email`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          // Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json(); // Parse the response

      if (response.ok) {
        message.success(data.message || "Email sent successfully!");
        setEmail('')
      } else {
        message.error(data.message || "Failed to send reset link. Try again!");
      }
    } catch {}
  };

  

  return (
    <div style={{height:'100%',overflow:'auto'}}>
      <HeaderSection/>
      <div className="scrollable-content">
      <div className='login-page'>
        <div className='signup-image'>
          <img src='/quelld-signup.png' className='signup-image' />
        </div>
        <div style={{ fontSize: "28px", justifyContent: "center", display: "flex", fontWeight: "500", paddingTop: "20%", paddingBottom: "8px" }}>Reset your password</div>
        <div style={{ fontSize: "16px", justifyContent: "center", display: "flex", color: "#767A83", textAlign: "center" }}>Enter your email or phone number. We'll send you a link to reset your password </div>

        <div style={{ marginTop: "48px" }}>
          <Form form={form} layout='vertical' onFinish={handleClick}>
            <Form.Item
              name='email'
              rules={[
                { required: true, message: "Please enter your email!" },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                  message: "Please enter a valid email address!",
                },
              ]}
            >
              <div className='floating-label'>
                <Input placeholder=' ' onChange={emailValue} value={email} 
                />
                <label>Email</label>
              </div>
            </Form.Item>
            <div style={{ paddingTop: "15px" ,marginBottom:'20px'}}>
              <Button type='primary' htmlType='submit' style={{ width: "394px", height: "52px" }}>
                Continue
              </Button>
            </div>
          </Form>
        </div>
      </div>
      </div>
      <FooterSection/>
    </div>
  );
};

export default ForgetPassword;
